import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecitemfield/cecItemField/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecitemfield/cecItemField/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecitemfield/cecItemField/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecitemfield/cecItemField/list',
      method: 'get',
      params: params
    })
  },

  listN: function (params) {
    return request({
      url: '/cecitemfield/cecItemField/listN',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecitemfield/cecItemField/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecitemfield/cecItemField/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecitemfield/cecItemField/import',
      method: 'post',
      data: data
    })
  },
  getCecitemUpdatePosition: function (params) {
    return request({
      url: '/cecitemfield/cecItemField/getCecitemUpdatePosition',
      method: 'post',
      params: params
    })
  }
}
